import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormControl,
  FormLabel,
  Input,
  Textarea,
  useToast
} from "@chakra-ui/react";
import { useState, useEffect } from "react";
import scheduleService from "services/report/scheduleService";

const ModalCreateST = ({ isOpen, onClose, sourceId, onSuccess }) => {
  const toast = useToast();

  const [form, setForm] = useState({
    no_surat: "",
    tanggal_surat: "",
    perihal: "",
    pejabat_ttd: ""
  });

  const [loading, setLoading] = useState(false);

  // reset form tiap modal dibuka
  useEffect(() => {
    if (isOpen) {
      setForm({
        no_surat: "",
        tanggal_surat: "",
        perihal: "",
        pejabat_ttd: ""
      });
    }
  }, [isOpen]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setForm((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async () => {
    if (!form.no_surat || !form.tanggal_surat || !form.perihal || !form.pejabat_ttd) {
      toast({
        title: "Validasi gagal",
        description: "Semua field wajib diisi",
        status: "warning",
        isClosable: true
      });
      return;
    }

    setLoading(true);
    try {
      const res = await scheduleService.createSuratTugasBySespri(sourceId, form);

      toast({
        title: "Berhasil",
        description: "Surat tugas berhasil dibuat",
        status: "success",
        isClosable: true
      });

      onSuccess(res.data.surat);
      onClose();
    } catch (err) {
      console.error("ERROR CREATE ST:", err.response?.data || err);
      toast({
        title: "Gagal",
        description: err.response?.data?.message || "Terjadi kesalahan",
        status: "error",
        isClosable: true
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose} size="lg" isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Buat Surat Tugas</ModalHeader>

        <ModalBody>
          <FormControl mb={3} isRequired>
            <FormLabel>Nomor Surat</FormLabel>
            <Input
              name="no_surat"
              placeholder="ST/001/2025"
              value={form.no_surat}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl mb={3} isRequired>
            <FormLabel>Tanggal Surat</FormLabel>
            <Input
              type="date"
              name="tanggal_surat"
              value={form.tanggal_surat}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl mb={3} isRequired>
            <FormLabel>Perihal</FormLabel>
            <Textarea
              name="perihal"
              placeholder="Surat Tugas Inspeksi..."
              value={form.perihal}
              onChange={handleChange}
            />
          </FormControl>

          <FormControl mb={3} isRequired>
            <FormLabel>Pejabat Penandatangan</FormLabel>
            <Input
              name="pejabat_ttd"
              placeholder="Sespri BPP MHKP"
              value={form.pejabat_ttd}
              onChange={handleChange}
            />
          </FormControl>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            Batal
          </Button>
          <Button
            colorScheme="green"
            onClick={handleSubmit}
            isLoading={loading}
          >
            Simpan Surat
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalCreateST;
